import { render, staticRenderFns } from "./Exit_button.vue?vue&type=template&id=20c22ecf"
import script from "./Exit_button.vue?vue&type=script&lang=js"
export * from "./Exit_button.vue?vue&type=script&lang=js"
import style0 from "./Exit_button.vue?vue&type=style&index=0&id=20c22ecf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports